import { EImportacaoType } from "../components/table/EImportacaoType";
import exportarXlsx from "./exportar-xlsx";
import { HttpService } from "../../services/http/http-client.service";

export function downloadErrorReport<T>(
  http: HttpService,
  loteId: number,
  importacaoType: EImportacaoType
) {
  let url;
  switch (importacaoType) {
    case EImportacaoType.CARGA:
      url = `/importacao-carga/${loteId}/itens-lote-carga/erro-validacao`;
      break;
    case EImportacaoType.FUNCIONARIO:
      url = `/importacao-funcionario/${loteId}/itens-lote-funcionario/erro-validacao`;
      break;
    default:
      break;
  }

  if (url) {
    http.doGet(
      url,
      null,
      (data) => {
        const dados: T[] = data.map((d) => {
          if (importacaoType === EImportacaoType.FUNCIONARIO) {
            return {
              "nome": d.nome,
              "cpf": d.cpf,
              "matricula": d.matricula,
              "telefone_celular": d.telefone,
              "email": d.email,
              "data_nascimento": d.dataNascimento,
              "nome_mae": d.nomeMae,
              "codigo_centro_de_custo": d.codigoCentroDeCusto,
              "motivo": d.motivoStatus,
            };
          }

          return {
            CPF: d.cpf,
            MATRICULA: d.matricula,
            VALOR: d.valor,
            MOTIVO: d.motivoStatus,
          };
        });
        exportarXlsx<T>(dados, "Relatório de erros");
      },
      (_error) => {
        this.notifications.alert(
          "Erro ao exportar o relatório de erros, entre em contato com o suporte técnico."
        );
      }
    );
  }
}
